import { CalendarRange, CalendarDays } from "lucide-react";

import { nzNow } from "@/lib/dates";
export const TERMS = ["Term 1", "Term 1 Holidays", "Term 2", "Term 2 Holidays", "Term 3", "Term 3 Holidays", "Term 4", "Summer Holidays"];

export function TermFilter({ value, onChange, idPrefix = "" }) {
  return (
    <div className="relative">
      <CalendarRange className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--hp-muted)] pointer-events-none" />
      <select data-testid={`${idPrefix}term-filter`} value={value} onChange={(e) => onChange(e.target.value)}
        className="appearance-none rounded-full border border-[var(--hp-border-hi)] bg-[var(--hp-card)] pl-9 pr-8 py-1.5 text-xs font-semibold text-[var(--hp-heading)] outline-none focus:border-[var(--hp-primary)] transition-colors cursor-pointer">
        <option value="">All terms</option>
        {TERMS.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
    </div>
  );
}

// A handful of recent years plus whatever's currently selected, so an old record's year is never
// silently missing from the dropdown even if it falls outside the usual lookback window.
export function yearOptions(selected) {
  const current = nzNow().getFullYear();
  const years = Array.from({ length: 7 }, (_, i) => current - i);
  if (selected && !years.includes(Number(selected))) years.push(Number(selected));
  return years.sort((a, b) => b - a);
}

export function YearFilter({ value, onChange, idPrefix = "" }) {
  return (
    <div className="relative">
      <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--hp-muted)] pointer-events-none" />
      <select data-testid={`${idPrefix}year-filter`} value={value} onChange={(e) => onChange(e.target.value)}
        className="appearance-none rounded-full border border-[var(--hp-border-hi)] bg-[var(--hp-card)] pl-9 pr-8 py-1.5 text-xs font-semibold text-[var(--hp-heading)] outline-none focus:border-[var(--hp-primary)] transition-colors cursor-pointer">
        <option value="">All years</option>
        {yearOptions(value).map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}
